import './filters_toggle_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['text']

  static values = {
    closedText: String,
    openText: String
  }

  connect = (): void => {
    this.changeText()
  }

  toggle = (): void => {
    this.changeText()
  }

  changeText = (): void => {
    if (this.open) {
      this.textTarget.innerHTML = this.openTextValue
    } else {
      this.textTarget.innerHTML = this.closedTextValue
    }
  }

  get open (): boolean {
    return this.filtersController.open
  }

  get filtersController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.filters'), 'filters')
  }
}
